import * as api from '../api/subcomponent';
import { createRequestTypes, START, SUCCESS, ERROR } from './global';
import { makeApiActionCreatorV3 } from '@actions/utils';

export const OBJECTS_FETCH = createRequestTypes('APPRAISAL/OBJECTS_FETCH');
export const OBJECT_SUBCOMPONENTS_FETCH = createRequestTypes(
  'APPRAISAL/OBJECT_SUBCOMPONENTS_FETCH',
);
export const SUBCOMPONENT_CREATE = createRequestTypes(
  'APPRAISAL/SUBCOMPONENT_CREATE',
);
export const SUBCOMPONENT_UPDATE = createRequestTypes(
  'APPRAISAL/SUBCOMPONENT_UPDATE',
);
export const SUBCOMPONENT_DELETE = createRequestTypes(
  'APPRAISAL/SUBCOMPONENT_DELETE',
);
// export const SUBCOMPONENT_DUPLICATE = createRequestTypes('APPRAISAL/SUBCOMPONENT_DUPLICATE');
export const SUBCOMPONENT_LIST_FETCH = createRequestTypes(
  'APPRAISAL/SUBCOMPONENT_LIST_FETCH',
);
export const SUBCOMPONENT_FETCH = createRequestTypes(
  'APPRAISAL/SUBCOMPONENT_FETCH',
);

export const SUBCOMPONENT_CHANGE_PAGE_SIZE =
  'APPRAISAL/SUBCOMPONENT_CHANGE_PAGE_SIZE';
export const SUBCOMPONENT_RESET_DATA = 'APPRAISAL/SUBCOMPONENT_RESET_DATA';

export const fetchObjects = makeApiActionCreatorV3(
  api.fetchAllObjects,
  OBJECTS_FETCH[START],
  OBJECTS_FETCH[SUCCESS],
  OBJECTS_FETCH[ERROR],
);
export const fetchObjectSubcomponents = makeApiActionCreatorV3(
  api.fetchSubcomponentsForObject,
  OBJECT_SUBCOMPONENTS_FETCH[START],
  OBJECT_SUBCOMPONENTS_FETCH[SUCCESS],
  OBJECT_SUBCOMPONENTS_FETCH[ERROR],
);
export const createSubcomponent = makeApiActionCreatorV3(
  api.createSubcomponent,
  SUBCOMPONENT_CREATE[START],
  SUBCOMPONENT_CREATE[SUCCESS],
  SUBCOMPONENT_CREATE[ERROR],
);
export const updateSubcomponent = makeApiActionCreatorV3(
  api.updateSubcomponent,
  SUBCOMPONENT_UPDATE[START],
  SUBCOMPONENT_UPDATE[SUCCESS],
  SUBCOMPONENT_UPDATE[ERROR],
);
export const deleteSubcomponent = makeApiActionCreatorV3(
  api.deleteSubcomponent,
  SUBCOMPONENT_DELETE[START],
  SUBCOMPONENT_DELETE[SUCCESS],
  SUBCOMPONENT_DELETE[ERROR],
);
export const fetchSubcomponents = makeApiActionCreatorV3(
  api.fetchSubcomponents,
  SUBCOMPONENT_LIST_FETCH[START],
  SUBCOMPONENT_LIST_FETCH[SUCCESS],
  SUBCOMPONENT_LIST_FETCH[ERROR],
);
export const fetchSubcomponent = makeApiActionCreatorV3(
  api.fetchSubcomponent,
  SUBCOMPONENT_FETCH[START],
  SUBCOMPONENT_FETCH[SUCCESS],
  SUBCOMPONENT_FETCH[ERROR],
);
// export const duplicateSubcomponent = makeApiActionCreatorV3(api.duplicateSubcomponent, SUBCOMPONENT_DUPLICATE[START], WEBPAGE_DUPLICATE[SUCCESS], WEBPAGE_DUPLICATE[ERROR]);

// export function changeCurrentPage (page) {
//   return async dispatch => {
//     dispatch({ type: WEBPAGE_CHANGE_CURRENT_PAGE, data: page });
//   };
// }

// export function changeSortModel (model) {
//   return async dispatch => {
//     dispatch({ type: WEBPAGE_CHANGE_SORT_MODEL, data: model });
//   };
// }

export function changePageSize(page) {
  return async dispatch => {
    dispatch({ type: SUBCOMPONENT_CHANGE_PAGE_SIZE, data: page });
  };
}

export function resetSubcomponentData() {
  return async dispatch => {
    dispatch({ type: SUBCOMPONENT_RESET_DATA });
  };
}
